<header class="mb-3 flex items-start justify-between gap-3">
  <h2 class="text-body text-gold-cream font-bold">{{ notification.title }}</h2>

  <button
    type="button"
    aria-label="Cerrar"
    class="text-blue-sky shrink-0 transition-transform duration-100 ease-out active:scale-95 motion-reduce:transition-none motion-reduce:active:scale-100"
    (click)="close()">
    <icon
      name="circle-x"
      [size]="20" />
  </button>
</header>

<p class="text-caption text-blue-sky mb-3 font-medium">{{ notification.date | date: "d MMM yyyy · hh:mm a" }}</p>

@if (notification.image; as image) {
<img
  class="mb-3 h-[152px] w-full rounded-xl object-cover"
  loading="lazy"
  [src]="image"
  alt="" />
}

<p class="text-label text-blue-frost leading-relaxed whitespace-pre-line">{{ notification.modalBody }}</p>

<div class="mt-5 flex gap-3">
  <button
    uiButton
    variant="secondary"
    class="flex-1"
    (click)="close()">
    Cerrar
  </button>

  @if (notification.link) {
  <button
    uiButton
    class="flex-1"
    data-test="notification-modal-link"
    (click)="go()">
    Ver más
  </button>
  }
</div>
